/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Badge from "@/components/Badge/Badge";
import { Typography } from "@mui/material";

import {
  colors,
  NavigationArrowRightRoundedIcon,
  SyncIcon
} from "@dotnet/telematics-design-system";

interface MiddleSectionProps {
  isMobile: boolean;
}

const MiddleSection = ({ isMobile }: MiddleSectionProps) => {
  const { t } = useTranslation();

  const lineWidth = isMobile ? "16px" : "38px";

  const renderLine = () => (
    <div
      css={css({
        width: lineWidth,
        height: "1px",
        backgroundColor: colors.textDisabled
      })}
    />
  );

  return (
    <div
      css={css({
        maxWidth: isMobile ? "110px" : "160px",
        justifyContent: "center",
        alignItems: "center"
      })}
    >
      <div
        css={css({
          display: "flex",
          gap: "4px",
          alignItems: "center",
          justifyContent: "center"
        })}
      >
        {renderLine()}
        <Badge color="success" changeTypography>
          <Typography variant={isMobile ? "body4Medium" : "body3Medium"}>
            {t("Dashboard##how credits work##top content##equals one credit")}
          </Typography>
        </Badge>
        {renderLine()}
      </div>

      <div
        css={css({
          margin: "8px 0",
          display: "flex",
          gap: "2px",
          alignItems: "center",
          justifyContent: "center"
        })}
      >
        <NavigationArrowRightRoundedIcon
          css={css({
            color: colors.textDisabled,
            rotate: "180deg",
            width: "16px",
            height: "16px"
          })}
        />
        <SyncIcon
          css={css({
            color: colors.textDisabled,
            width: "16px",
            height: "16px"
          })}
        />
      </div>

      <Typography
        variant="body4Medium"
        component="div"
        css={css(
          {
            color: colors.textSecondary,
            minHeight: "40px",
            textAlign: "center",
            maxWidth: isMobile ? "50px" : "80px",
            margin: "0 auto"
          },
          isMobile && {
            fontSize: "5px",
            lineHeight: "6px"
          }
        )}
      >
        {t(
          "Dashboard##how credits work##top content##device can change freely"
        )}
      </Typography>
    </div>
  );
};

export default MiddleSection;
